import React, { useEffect, useState } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ContentMain } from "./ContentMain";
import "./FriendAndFamily.css";
import "./MyStyles/style.css";
import "./MyStyles/responsive.css";
import { useSearchParams } from "react-router-dom";
import swal from "sweetalert";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const FriendAndFamily = () => {
  const [searchParams] = useSearchParams();
  const queryValue = searchParams.get("at");

  const [data, setData] = useState([]);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [atValidationreq, setAtValidationreq] = useState({
    MobileNo: "",
    OTTSMSID: null,
    AuthToken: "",
  });

  const ValidateToken = (mno, ottsmsid, at) => {
    const req = {
      MobileNo: mno,
      OTTSMSID: parseInt(ottsmsid),
      AuthToken: at,
    };

    fetch(`${apiBaseURL}/api/FriendAndFamily/ValidationToken`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(req),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((resultInfo) => {
        if (resultInfo && resultInfo.resultStatus === "Success") {
          if (
            resultInfo.resultCode === 0 &&
            resultInfo.result === "Token is validated"
          ) {
            setIsTokenValid(true);
          } else {
            handleInvalidtoken("Invalid token. Please try again.");
          }
        } else {
          handleInvalidtoken("Invalid token. Please try again.");
        }
      })
      .catch((err) => {
        handleInvalidtoken(err.message);
        console.error("Error while validating token:", err);
      });
  };

  const handleInvalidtoken = (msg) => {
    setIsTokenValid(false);
    swal({
      title: "",
      text: msg,
      icon: "error",
      buttons: {
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "",
          closeModal: true,
        },
      },
    }).then(() => {
      window.location.replace("https://www.vzy.one/");
    });
  };

  useEffect(() => {
    document.title = "Family And Friends";

    if (queryValue !== null && queryValue !== "") {
      const strDecoded = atob(queryValue);
      const params = new URLSearchParams(strDecoded);

      // Extract values
      const mno = params.get("mno");
      const ottsmsid = params.get("ottsmsid");
      const at = params.get("at");
      setAtValidationreq({
        MobileNo: mno,
        OTTSMSID: ottsmsid,
        AuthToken: at,
      });

      if (mno !== "" && mno !== null && ottsmsid > 0 && at !== "") {
        ValidateToken(mno, ottsmsid, at);
      }
    }

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${apiBaseURL}/api/FriendAndFamily/GetAvilableSubscriptionPlanDetails`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        return data.result;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData()
      .then((result) => {
        setData(result);
      })
      .catch(() => {});
  }, [queryValue]);

  return (
    <div className="fullHeight minHeight backgroundBlack containnerMain">
      <Header />
      <ContentMain
        data={data}
        isTokenValid={isTokenValid}
        reqParams={atValidationreq}
      />
      <Footer />
    </div>
  );
};
